exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../node_modules/css-loader/index.js!vue-directive-tooltip/css/index.css"), "");

// module
exports.push([module.id, ".payment-profile[data-v-4d58adf2] {\n  margin: 1.5em 0 2em 0;\n}\n", ""]);

// exports
